export const DisplayLayouts = [
    { id: 'clock', nameKey: 'layouts.clock' },
    { id: 'dashboard', nameKey: 'layouts.dashboard' }
];
